export default "__VITE_ASSET__a93ddc06__"